import React from "react";
import styled from "styled-components";
import {subduedTextColour} from "../../../style/styleConsts";
import IdeaType from "../../idea/IdeaType";
import {RedactCommentary} from "../../redact/RedactCommentary";

const Container = styled.div`
    display: flex;
`;

const ActivityCell = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0 5px;
    flex-shrink: 0;
    display: inline-block;
`;

const Direction = styled(ActivityCell)`
    width: 4em;
`;

const Author = styled(ActivityCell)`
    width: 10em;
    color: ${subduedTextColour};
`

const Comment = styled(ActivityCell)`
    flex-grow: 1;
    flex-shrink: 1;
    color: ${subduedTextColour};
`

const StockAction = ({ideaType, authorName, comment}) => (
    <Container>
        <Direction className="t-idea-type"><IdeaType type={ideaType}/></Direction>
        <Author className="t-author">{authorName}</Author>
        <Comment className="t-comment"><RedactCommentary>{comment}</RedactCommentary></Comment>
    </Container>
);

export default StockAction;
